class PortalButton extends HTMLElement {
    constructor() {
        super();

        this.portalId = this.dataset?.portalId;
        this.element = document.getElementById(this.portalId);
    }

    connectedCallback() {
        if (!this.element) {
            console.error(`Portal Element with id ${this.portalId} not found`);
            return;
        }

        this.addEventListener('click', this.selectElement.bind(this));
    }

    selectElement() {
        this.element?.click();
    }
}

if (!customElements.get('portal-button')) {
    customElements.define('portal-button', PortalButton);
}